import { render } from "./MobileNavList.vue?vue&type=template&id=20e1e1b6&scoped=true"
import script from "./MobileNavList.vue?vue&type=script&lang=js"
export * from "./MobileNavList.vue?vue&type=script&lang=js"

import "./MobileNavList.vue?vue&type=style&index=0&id=20e1e1b6&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e1e1b6"]])

export default __exports__